import React from "react";
import FuelLogConsumptionHistory from "../../../fuel/components/FuelLogConsumptionHistory";
import VehicleFuelCard from "../../../fuel/components/VehicleFuelCard";
import { Vehicle } from "../../@types";

interface FuelConsumptionTabProps {
  vehicleId: string;
  vehicle?: Vehicle;
}

const FuelConsumptionTab: React.FC<FuelConsumptionTabProps> = ({
  vehicleId,
  vehicle,
}) => {
  return (
    <div className="space-y-4">
      {vehicle && <VehicleFuelCard vehicle={vehicle} />}
      {/* <FuelLogGraph vehicleId={vehicleId} /> */}
      <FuelLogConsumptionHistory vehicleId={vehicleId} />
    </div>
  );
};

export default FuelConsumptionTab;
